(function () {
  const parseJSON = (node) => {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('Failed to parse cart progress bar data', error);
      return null;
    }
  };

  const normalizeAmount = (value) => {
    if (typeof value === 'number') return value;
    if (typeof value === 'string' && value.trim() !== '') {
      const parsed = parseInt(value, 10);
      return isNaN(parsed) ? null : parsed;
    }
    return null;
  };

  const updateGWPProgressBar = (cartTotalPrice) => {
    const progressBar = document.querySelector('[data-gwp-progress]');
    if(!progressBar) {
      return;
    }
    const progressBarData = parseJSON(document.getElementById('gwp-progress-bar-data'));
    const normalizedTotal = normalizeAmount(cartTotalPrice);
		const freeShippingTarget = normalizeAmount(progressBarData.gwp_free_shipping_target);
		let shippingFee = normalizeAmount(progressBarData.gwp_setting_shipping_fee);
		if(cartTotalPrice >= freeShippingTarget) {
			shippingFee = 0;
		}

    if (!progressBar || !progressBarData || normalizedTotal === null) {
      return;
    }

    const targetAmount = normalizeAmount(progressBarData.gwp_progress);
    if (!targetAmount || targetAmount <= 0) {
      return;
    }

    const progressText = progressBarData.gwp_progress_text || '';
    const completedText = progressBarData.gwp_completed_text || '';
    const currentAmount = normalizedTotal + shippingFee;
    const progressPercent = Math.min((currentAmount / targetAmount) * 100, 100);
    const remaining = Math.max(targetAmount - currentAmount, 0);

    const fillElement = progressBar.querySelector('[data-gwp-fill]');
    const remainingElement = progressBar.querySelector('[data-gwp-remaining]');

    if (fillElement) {
      fillElement.style.width = `${progressPercent}%`;
    }

    if (currentAmount >= targetAmount) {
      if (remainingElement) remainingElement.textContent = completedText;
      progressBar.classList.add('is-completed');
    } else if (remainingElement) {
      const remainingYen = Math.floor(remaining / 100);
      const displayText = progressText.replace('[amount]', `¥${remainingYen.toLocaleString()}`);
      remainingElement.textContent = displayText;
      progressBar.classList.remove('is-completed');
    }
  };

  const updateFreeShippingProgressBar = (cartSubtotalPrice) => {
    const progressBarArea = document.querySelector('[data-progress-bar-area]');
    if(!progressBarArea) {
      return;
    }
    const progressBar = document.querySelector('[data-shipping-free-progress]');
    if(!progressBar) {
      return;
    }
    const progressBarData = parseJSON(document.getElementById('shipping-free-progress-bar-data'));
    const normalizedSubtotal = normalizeAmount(cartSubtotalPrice);

    if (!progressBarArea || !progressBar || !progressBarData || normalizedSubtotal === null) {
      return;
    }

    const targetAmount = normalizeAmount(progressBarData.free_shipping_progress);
    if (!targetAmount || targetAmount <= 0) {
      return;
    }

    const freeShippingMemberFlg = !!progressBarData.free_shipping_member_flg;
    const progressText = progressBarData.shipping_free_progress_text || '';
    const completedText = progressBarData.shipping_free_completed_text || '';

    let progressPercent;
    let remaining;

    if (freeShippingMemberFlg) {
      progressPercent = 100;
      remaining = 0;
    } else {
      progressPercent = Math.min((normalizedSubtotal / targetAmount) * 100, 100);
      remaining = Math.max(targetAmount - normalizedSubtotal, 0);
    }

    const fillElement = progressBar.querySelector('[data-shipping-free-fill]');
    const remainingElement = progressBar.querySelector('[data-shipping-free-remaining]');
    const rewardElement = progressBarArea.querySelector('[data-gwp-progress]');
    const banner = document.querySelector('.cart-header-banner');

    if (fillElement) {
      fillElement.style.width = `${progressPercent}%`;
    }

    if (progressPercent >= 100) {
      progressBar.setAttribute('hidden', 'hidden');
      if (!rewardElement && !banner) {
        progressBarArea.setAttribute('hidden', 'hidden');
      }
      if (remainingElement) remainingElement.textContent = completedText;
      progressBar.classList.add('is-completed');
    } else {
      progressBar.removeAttribute('hidden');
      if (!rewardElement && !banner) {
        progressBarArea.removeAttribute('hidden');
      }
      if (remainingElement) {
        const remainingYen = Math.floor(remaining / 100);
        const displayText = progressText.replace('[amount]', `¥${remainingYen.toLocaleString()}`);
        remainingElement.textContent = displayText;
      }
      progressBar.classList.remove('is-completed');
    }
  };

  window.updateGWPProgressBar = updateGWPProgressBar;
  window.updateFreeShippingProgressBar = updateFreeShippingProgressBar;
})();
